export default __webpack_public_path__ + "static/media/gallery-power_01.78416ded.jpg";